import React, { useState, useEffect, useRef, useCallback } from "react";
import Image from "../fragments/Image";

const PageWhoAreWe = ({ block }) => {

    if (!block) return null;

    return (
        <div className="c-page__block c-page__block--who-are-we">
            {block.heading &&
                <h3 className="c-page__block__heading" dangerouslySetInnerHTML={{ __html: block.heading }}></h3>
            }
            <div className="c-who-are-we">
                <div className="l-grid">
                    {block.introduction &&
                        <div className="l-grid__col l-grid__col--m-8-12 l-grid__col--l-6-12">
                            <div className="c-who-are-we__introduction scope-medium-text scope-medium-text--faded" dangerouslySetInnerHTML={{ __html: `<p>${block.introduction}</p>` }}></div>
                        </div>
                    }
                    {block.text &&
                        <div className="l-grid__col l-grid__col--m-8-12 l-grid__col--l-6-12">
                            <div className="c-who-are-we__text scope-text scope-text--faded" dangerouslySetInnerHTML={{ __html: `${block.text}` }}></div>
                        </div>
                    }
                    <div className="l-grid__col l-grid__col--l-10-12 l-grid__col--l-push-1-12">
                        {block.image_src &&
                            <Image 
                                width={block.image_width}
                                height={block.image_height}
                                src={block.image_src} 
                                alt={''}
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageWhoAreWe;
